import { type ReactNode, createContext, useContext } from "react";

export type PageContext = {
  page: string;
  route: string;
  pageTitle: string;
  selected?: {
    type: "deal" | "company" | "contact" | "partner" | "task" | "campaign" | "document";
    id: string;
    label: string;
  };
  filters?: Record<string, string | number | boolean | string[]>;
  visibleData?: {
    summary?: Record<string, unknown>;
    rows?: Array<Record<string, unknown>>;
    [key: string]: unknown;
  };
  view?: "global" | "mine";
  ownerEmail?: string | null;
  pipelineType?: "new_business" | "expansion" | "renewal";
  suggestedPrompts?: string[];
};

const PageContextCtx = createContext<PageContext | null>(null);

export function PageContextProvider({
  value,
  children,
}: {
  value: PageContext;
  children: ReactNode;
}) {
  return <PageContextCtx.Provider value={value}>{children}</PageContextCtx.Provider>;
}

export function usePageContext(): PageContext | null {
  return useContext(PageContextCtx);
}
